import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegistrationRoutingModule } from './registration-routing.module';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { ConfirmRegistrationModalComponent } from './confirm-registration-modal/confirm-registration-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from "primeng/checkbox";
import { AccountCreationModalComponent } from './account-creation-modal/account-creation-modal.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { PhoneRecoveryEmailComponent } from './phone-recovery-email/phone-recovery-email.component';
import { PhoneUpdateComponent } from './phone-update/phone-update.component';
import { PhoneUpdateRecoveryEmailComponent } from './phone-update-recovery-email/phone-update-recovery-email.component';
import { VerificationSuccessComponent } from './verification-success/verification-success.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { RegistrationExpiredComponent } from './registration-expired/registration-expired.component';
import { ModalComponent } from '../shared/custom-component/modal/modal.component';
import { PhoneMaskDirective } from '../shared/directives/phone-mask.directive';


@NgModule({
  declarations: [
    RegistrationFormComponent,
    ConfirmRegistrationModalComponent,
    AccountCreationModalComponent,
    PhoneVerificationComponent,
    PhoneRecoveryEmailComponent,
    PhoneUpdateComponent,
    PhoneUpdateRecoveryEmailComponent,
    VerificationSuccessComponent,
    CreatePasswordComponent,
    RegistrationExpiredComponent,
  ],
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CheckboxModule,
    ModalComponent,
    PhoneMaskDirective,
]
})
export class RegistrationModule { }
